/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-9ecdf98c.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _circle, _circle2, _circle3, _path126, _circle4, _circle5, _circle6, _path127, _circle7, _circle8, _circle9, _path128, _circle10, _circle11, _circle12, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _circle13, _circle14, _circle15, _path150, _path151, _circle16, _circle17, _circle18, _path152, _path153, _circle19, _circle20, _circle21, _path154, _path155, _circle22, _circle23, _circle24, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _circle25, _circle26, _circle27, _path169, _path170, _circle28, _circle29, _circle30, _path171, _path172, _circle31, _circle32, _circle33, _path173, _path174, _circle34, _circle35, _circle36, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _circle37, _path197, _circle38, _path198, _circle39, _path199, _circle40, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _circle41, _path213, _circle42, _circle43, _circle44, _path214, _circle45, _path215, _circle46, _circle47, _circle48, _path216, _circle49, _path217, _circle50, _circle51, _circle52, _path218, _circle53, _path219, _circle54, _circle55, _circle56, _path220, _circle57, _path221, _path222, _circle58, _path223, _path224, _circle59, _path225, _path226, _circle60, _path227, _path228, _path229, _circle61, _path230, _path231, _circle62, _path232, _path233, _circle63, _path234, _path235, _circle64, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _circle65, _circle66, _circle67, _path245, _path246, _circle68, _circle69, _circle70, _path247, _path248, _circle71, _circle72, _circle73, _path249, _path250, _circle74, _circle75, _circle76, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _circle77, _path273, _circle78, _path274, _circle79, _path275, _circle80, _path276, _circle81, _path277, _path278, _circle82, _path279, _path280, _circle83, _path281, _path282, _circle84, _path283, _path284, _path285, _path286, _path287, _path288, _switch, _switch2, _switch3, _switch4, _switch5, _switch6, _switch7, _switch8, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _switch9, _switch10, _switch11, _switch12, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var Currency20 = /*#__PURE__*/React.forwardRef(function Currency20(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
  })), children);
});
var Currency16 = /*#__PURE__*/React.forwardRef(function Currency16(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
  })), children);
});
var CurrencyBaht32 = /*#__PURE__*/React.forwardRef(function CurrencyBaht32(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
  })), children);
});
var CurrencyBaht24 = /*#__PURE__*/React.forwardRef(function CurrencyBaht24(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
  })), children);
});
var CurrencyBaht20 = /*#__PURE__*/React.forwardRef(function CurrencyBaht20(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
  })), children);
});
var CurrencyBaht16 = /*#__PURE__*/React.forwardRef(function CurrencyBaht16(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
  })), children);
});
var CurrencyDollar32 = /*#__PURE__*/React.forwardRef(function CurrencyDollar32(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
  })), children);
});
var CurrencyDollar24 = /*#__PURE__*/React.forwardRef(function CurrencyDollar24(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
  })), children);
});
var CurrencyDollar20 = /*#__PURE__*/React.forwardRef(function CurrencyDollar20(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
  })), children);
});
var CurrencyDollar16 = /*#__PURE__*/React.forwardRef(function CurrencyDollar16(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
  })), children);
});
var CurrencyEuro32 = /*#__PURE__*/React.forwardRef(function CurrencyEuro32(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
  })), children);
});
var CurrencyEuro24 = /*#__PURE__*/React.forwardRef(function CurrencyEuro24(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
  })), children);
});
var CurrencyEuro20 = /*#__PURE__*/React.forwardRef(function CurrencyEuro20(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
  })), children);
});
var CurrencyEuro16 = /*#__PURE__*/React.forwardRef(function CurrencyEuro16(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
  })), children);
});
var CurrencyLira32 = /*#__PURE__*/React.forwardRef(function CurrencyLira32(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
  })), children);
});
var CurrencyLira24 = /*#__PURE__*/React.forwardRef(function CurrencyLira24(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
  })), children);
});
var CurrencyLira20 = /*#__PURE__*/React.forwardRef(function CurrencyLira20(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
  })), children);
});
var CurrencyLira16 = /*#__PURE__*/React.forwardRef(function CurrencyLira16(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
  })), children);
});
var CurrencyPound32 = /*#__PURE__*/React.forwardRef(function CurrencyPound32(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
  })), children);
});
var CurrencyPound24 = /*#__PURE__*/React.forwardRef(function CurrencyPound24(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
  })), children);
});
var CurrencyPound20 = /*#__PURE__*/React.forwardRef(function CurrencyPound20(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
  })), children);
});
var CurrencyPound16 = /*#__PURE__*/React.forwardRef(function CurrencyPound16(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
  })), children);
});
var CurrencyRuble32 = /*#__PURE__*/React.forwardRef(function CurrencyRuble32(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
var CurrencyRuble24 = /*#__PURE__*/React.forwardRef(function CurrencyRuble24(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
var CurrencyRuble20 = /*#__PURE__*/React.forwardRef(function CurrencyRuble20(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
var CurrencyRuble16 = /*#__PURE__*/React.forwardRef(function CurrencyRuble16(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
var CurrencyRupee32 = /*#__PURE__*/React.forwardRef(function CurrencyRupee32(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
  })), children);
});
var CurrencyRupee24 = /*#__PURE__*/React.forwardRef(function CurrencyRupee24(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
  })), children);
});
var CurrencyRupee20 = /*#__PURE__*/React.forwardRef(function CurrencyRupee20(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
  })), children);
});
var CurrencyRupee16 = /*#__PURE__*/React.forwardRef(function CurrencyRupee16(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
  })), children);
});
var CurrencyShekel32 = /*#__PURE__*/React.forwardRef(function CurrencyShekel32(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
  })), children);
});
var CurrencyShekel24 = /*#__PURE__*/React.forwardRef(function CurrencyShekel24(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
  })), children);
});
var CurrencyShekel20 = /*#__PURE__*/React.forwardRef(function CurrencyShekel20(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
  })), children);
});
var CurrencyShekel16 = /*#__PURE__*/React.forwardRef(function CurrencyShekel16(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
  })), children);
});
var CurrencyWon32 = /*#__PURE__*/React.forwardRef(function CurrencyWon32(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
  })), children);
});
var CurrencyWon24 = /*#__PURE__*/React.forwardRef(function CurrencyWon24(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
  })), children);
});
var CurrencyWon20 = /*#__PURE__*/React.forwardRef(function CurrencyWon20(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
  })), children);
});
var CurrencyWon16 = /*#__PURE__*/React.forwardRef(function CurrencyWon16(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
  })), children);
});
var CurrencyYen32 = /*#__PURE__*/React.forwardRef(function CurrencyYen32(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
  })), children);
});
var CurrencyYen24 = /*#__PURE__*/React.forwardRef(function CurrencyYen24(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
  })), children);
});
var CurrencyYen20 = /*#__PURE__*/React.forwardRef(function CurrencyYen20(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
  })), children);
});
var CurrencyYen16 = /*#__PURE__*/React.forwardRef(function CurrencyYen16(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
  })), children);
});
var Cursor_132 = /*#__PURE__*/React.forwardRef(function Cursor_132(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
  })), children);
});
var Cursor_124 = /*#__PURE__*/React.forwardRef(function Cursor_124(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
  })), children);
});
var Cursor_120 = /*#__PURE__*/React.forwardRef(function Cursor_120(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
  })), children);
});
var Cursor_116 = /*#__PURE__*/React.forwardRef(function Cursor_116(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
  })), children);
});
var Cursor_232 = /*#__PURE__*/React.forwardRef(function Cursor_232(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
  })), children);
});
var Cursor_224 = /*#__PURE__*/React.forwardRef(function Cursor_224(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
  })), children);
});
var Cursor_220 = /*#__PURE__*/React.forwardRef(function Cursor_220(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
  })), children);
});
var Cursor_216 = /*#__PURE__*/React.forwardRef(function Cursor_216(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
  })), children);
});
var Customer32 = /*#__PURE__*/React.forwardRef(function Customer32(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7554 21.3447c-.1899-.2188-.4656-.3447-.7554-.3447h-2v-2c0-1.1025-.8972-2-2-2h-4c-1.1028 0-2 .8975-2 2v2h-2c-.2898 0-.5654.126-.7554.3447-.1899.2192-.2756.5098-.2346.7969l1 7c.0703.4922.4924.8584.99.8584h10c.4976 0 .9197-.3662.99-.8584l1-7c.041-.2871-.0447-.5776-.2346-.7969zm-8.7554-2.3447h4v2h-4v-2zm6.1328 9h-8.2656l-.7141-5h9.6938l-.7141 5zM10 20H12V30H10z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 17.875l-1.9072-2.3838-1.4419-3.6055c-.4585-1.1455-1.5518-1.8857-2.7856-1.8857h-5.646c-1.6543 0-3 1.3457-3 3v7c0 1.1025.897 2 2 2h1v8h2v-10h-3v-7c0-.5518.4487-1 1-1h5.646c.4111 0 .7759.2471.9282.6289l1.645 3.9961 2 2.5 1.5615-1.25zM4 5c0-2.2056 1.7944-4 4-4s4 1.7944 4 4c0 2.2056-1.7944 4-4 4s-4-1.7944-4-4zm2 0c0 1.1028.897 2 2 2s2-.8972 2-2c0-1.1028-.897-2-2-2s-2 .8972-2 2z"
  })), children);
});
var Customer24 = /*#__PURE__*/React.forwardRef(function Customer24(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7554 21.3447c-.1899-.2188-.4656-.3447-.7554-.3447h-2v-2c0-1.1025-.8972-2-2-2h-4c-1.1028 0-2 .8975-2 2v2h-2c-.2898 0-.5654.126-.7554.3447-.1899.2192-.2756.5098-.2346.7969l1 7c.0703.4922.4924.8584.99.8584h10c.4976 0 .9197-.3662.99-.8584l1-7c.041-.2871-.0447-.5776-.2346-.7969zm-8.7554-2.3447h4v2h-4v-2zm6.1328 9h-8.2656l-.7141-5h9.6938l-.7141 5zM10 20H12V30H10z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 17.875l-1.9072-2.3838-1.4419-3.6055c-.4585-1.1455-1.5518-1.8857-2.7856-1.8857h-5.646c-1.6543 0-3 1.3457-3 3v7c0 1.1025.897 2 2 2h1v8h2v-10h-3v-7c0-.5518.4487-1 1-1h5.646c.4111 0 .7759.2471.9282.6289l1.645 3.9961 2 2.5 1.5615-1.25zM4 5c0-2.2056 1.7944-4 4-4s4 1.7944 4 4c0 2.2056-1.7944 4-4 4s-4-1.7944-4-4zm2 0c0 1.1028.897 2 2 2s2-.8972 2-2c0-1.1028-.897-2-2-2s-2 .8972-2 2z"
  })), children);
});
var Customer20 = /*#__PURE__*/React.forwardRef(function Customer20(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7554 21.3447c-.1899-.2188-.4656-.3447-.7554-.3447h-2v-2c0-1.1025-.8972-2-2-2h-4c-1.1028 0-2 .8975-2 2v2h-2c-.2898 0-.5654.126-.7554.3447-.1899.2192-.2756.5098-.2346.7969l1 7c.0703.4922.4924.8584.99.8584h10c.4976 0 .9197-.3662.99-.8584l1-7c.041-.2871-.0447-.5776-.2346-.7969zm-8.7554-2.3447h4v2h-4v-2zm6.1328 9h-8.2656l-.7141-5h9.6938l-.7141 5zM10 20H12V30H10z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 17.875l-1.9072-2.3838-1.4419-3.6055c-.4585-1.1455-1.5518-1.8857-2.7856-1.8857h-5.646c-1.6543 0-3 1.3457-3 3v7c0 1.1025.897 2 2 2h1v8h2v-10h-3v-7c0-.5518.4487-1 1-1h5.646c.4111 0 .7759.2471.9282.6289l1.645 3.9961 2 2.5 1.5615-1.25zM4 5c0-2.2056 1.7944-4 4-4s4 1.7944 4 4c0 2.2056-1.7944 4-4 4s-4-1.7944-4-4zm2 0c0 1.1028.897 2 2 2s2-.8972 2-2c0-1.1028-.897-2-2-2s-2 .8972-2 2z"
  })), children);
});
var Customer16 = /*#__PURE__*/React.forwardRef(function Customer16(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7554 21.3447c-.1899-.2188-.4656-.3447-.7554-.3447h-2v-2c0-1.1025-.8972-2-2-2h-4c-1.1028 0-2 .8975-2 2v2h-2c-.2898 0-.5654.126-.7554.3447-.1899.2192-.2756.5098-.2346.7969l1 7c.0703.4922.4924.8584.99.8584h10c.4976 0 .9197-.3662.99-.8584l1-7c.041-.2871-.0447-.5776-.2346-.7969zm-8.7554-2.3447h4v2h-4v-2zm6.1328 9h-8.2656l-.7141-5h9.6938l-.7141 5zM10 20H12V30H10z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 17.875l-1.9072-2.3838-1.4419-3.6055c-.4585-1.1455-1.5518-1.8857-2.7856-1.8857h-5.646c-1.6543 0-3 1.3457-3 3v7c0 1.1025.897 2 2 2h1v8h2v-10h-3v-7c0-.5518.4487-1 1-1h5.646c.4111 0 .7759.2471.9282.6289l1.645 3.9961 2 2.5 1.5615-1.25zM4 5c0-2.2056 1.7944-4 4-4s4 1.7944 4 4c0 2.2056-1.7944 4-4 4s-4-1.7944-4-4zm2 0c0 1.1028.897 2 2 2s2-.8972 2-2c0-1.1028-.897-2-2-2s-2 .8972-2 2z"
  })), children);
});
var CustomerService32 = /*#__PURE__*/React.forwardRef(function CustomerService32(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM22 6v4c0 1.1025-.8972 2-2 2h-1c-.5522 0-1 .4478-1 1s.4478 1 1 1h1c2.2056 0 4-1.7944 4-4v-4h-2zM16 16c-3.8599 0-7-3.1401-7-7S12.1401 2 16 2c1.9885 0 3.8901.8503 5.2173 2.3329l-1.4902 1.334c-.9482-1.0593-2.3066-1.6669-3.7271-1.6669-2.7571 0-5 2.243-5 5s2.2429 5 5 5v2z"
  })), children);
});
var CustomerService24 = /*#__PURE__*/React.forwardRef(function CustomerService24(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM22 6v4c0 1.1025-.8972 2-2 2h-1c-.5522 0-1 .4478-1 1s.4478 1 1 1h1c2.2056 0 4-1.7944 4-4v-4h-2zM16 16c-3.8599 0-7-3.1401-7-7S12.1401 2 16 2c1.9885 0 3.8901.8503 5.2173 2.3329l-1.4902 1.334c-.9482-1.0593-2.3066-1.6669-3.7271-1.6669-2.7571 0-5 2.243-5 5s2.2429 5 5 5v2z"
  })), children);
});
var CustomerService20 = /*#__PURE__*/React.forwardRef(function CustomerService20(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM22 6v4c0 1.1025-.8972 2-2 2h-1c-.5522 0-1 .4478-1 1s.4478 1 1 1h1c2.2056 0 4-1.7944 4-4v-4h-2zM16 16c-3.8599 0-7-3.1401-7-7S12.1401 2 16 2c1.9885 0 3.8901.8503 5.2173 2.3329l-1.4902 1.334c-.9482-1.0593-2.3066-1.6669-3.7271-1.6669-2.7571 0-5 2.243-5 5s2.2429 5 5 5v2z"
  })), children);
});
var CustomerService16 = /*#__PURE__*/React.forwardRef(function CustomerService16(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM22 6v4c0 1.1025-.8972 2-2 2h-1c-.5522 0-1 .4478-1 1s.4478 1 1 1h1c2.2056 0 4-1.7944 4-4v-4h-2zM16 16c-3.8599 0-7-3.1401-7-7S12.1401 2 16 2c1.9885 0 3.8901.8503 5.2173 2.3329l-1.4902 1.334c-.9482-1.0593-2.3066-1.6669-3.7271-1.6669-2.7571 0-5 2.243-5 5s2.2429 5 5 5v2z"
  })), children);
});
var Cut32 = /*#__PURE__*/React.forwardRef(function Cut32(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
  })), children);
});
var Cut24 = /*#__PURE__*/React.forwardRef(function Cut24(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
  })), children);
});
var Cut20 = /*#__PURE__*/React.forwardRef(function Cut20(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
  })), children);
});
var Cut16 = /*#__PURE__*/React.forwardRef(function Cut16(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
  })), children);
});
var WatsonHealthCutInHalf32 = /*#__PURE__*/React.forwardRef(function WatsonHealthCutInHalf32(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
  })), children);
});
var WatsonHealthCutInHalf24 = /*#__PURE__*/React.forwardRef(function WatsonHealthCutInHalf24(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
  })), children);
});
var WatsonHealthCutInHalf20 = /*#__PURE__*/React.forwardRef(function WatsonHealthCutInHalf20(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
  })), children);
});
var WatsonHealthCutInHalf16 = /*#__PURE__*/React.forwardRef(function WatsonHealthCutInHalf16(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
  })), children);
});
var CutOut32 = /*#__PURE__*/React.forwardRef(function CutOut32(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
  })), children);
});
var CutOut24 = /*#__PURE__*/React.forwardRef(function CutOut24(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
  })), children);
});
var CutOut20 = /*#__PURE__*/React.forwardRef(function CutOut20(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
  })), children);
});
var CutOut16 = /*#__PURE__*/React.forwardRef(function CutOut16(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
  })), children);
});
var QCY32 = /*#__PURE__*/React.forwardRef(function QCY32(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
  })), children);
});
var QCY24 = /*#__PURE__*/React.forwardRef(function QCY24(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
  })), children);
});
var QCY20 = /*#__PURE__*/React.forwardRef(function QCY20(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
  })), children);
});
var QCY16 = /*#__PURE__*/React.forwardRef(function QCY16(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
  })), children);
});
var Cyclist32 = /*#__PURE__*/React.forwardRef(function Cyclist32(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
  })), children);
});
var Cyclist24 = /*#__PURE__*/React.forwardRef(function Cyclist24(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
  })), children);
});
var Cyclist20 = /*#__PURE__*/React.forwardRef(function Cyclist20(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
  })), children);
});
var Cyclist16 = /*#__PURE__*/React.forwardRef(function Cyclist16(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
  })), children);
});
var QCZ32 = /*#__PURE__*/React.forwardRef(function QCZ32(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
  })), children);
});
var QCZ24 = /*#__PURE__*/React.forwardRef(function QCZ24(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
  })), children);
});
var QCZ20 = /*#__PURE__*/React.forwardRef(function QCZ20(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
  })), children);
});
var QCZ16 = /*#__PURE__*/React.forwardRef(function QCZ16(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
  })), children);
});
var Dashboard32 = /*#__PURE__*/React.forwardRef(function Dashboard32(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
  })), children);
});
var Dashboard24 = /*#__PURE__*/React.forwardRef(function Dashboard24(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
  })), children);
});
var Dashboard20 = /*#__PURE__*/React.forwardRef(function Dashboard20(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
  })), children);
});
var Dashboard16 = /*#__PURE__*/React.forwardRef(function Dashboard16(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
  })), children);
});
var DashboardReference32 = /*#__PURE__*/React.forwardRef(function DashboardReference32(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
  })), children);
});
var DashboardReference24 = /*#__PURE__*/React.forwardRef(function DashboardReference24(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
  })), children);
});
var DashboardReference20 = /*#__PURE__*/React.forwardRef(function DashboardReference20(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
  })), children);
});
var DashboardReference16 = /*#__PURE__*/React.forwardRef(function DashboardReference16(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
  })), children);
});
var Data_132 = /*#__PURE__*/React.forwardRef(function Data_132(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
  })), children);
});
var Data_124 = /*#__PURE__*/React.forwardRef(function Data_124(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
  })), children);
});
var Data_120 = /*#__PURE__*/React.forwardRef(function Data_120(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
  })), children);
});
var Data_116 = /*#__PURE__*/React.forwardRef(function Data_116(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
  })), children);
});
var Data_232 = /*#__PURE__*/React.forwardRef(function Data_232(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
  })), children);
});
var Data_224 = /*#__PURE__*/React.forwardRef(function Data_224(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
  })), children);
});
var Data_220 = /*#__PURE__*/React.forwardRef(function Data_220(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
  })), children);
});
var Data_216 = /*#__PURE__*/React.forwardRef(function Data_216(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
  })), children);
});
var DataBase32 = /*#__PURE__*/React.forwardRef(function DataBase32(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), children);
});
var DataBase24 = /*#__PURE__*/React.forwardRef(function DataBase24(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), children);
});
var DataBase20 = /*#__PURE__*/React.forwardRef(function DataBase20(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), children);
});
var DataBase16 = /*#__PURE__*/React.forwardRef(function DataBase16(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), children);
});
var DataBaseAlt32 = /*#__PURE__*/React.forwardRef(function DataBaseAlt32(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
  })), children);
});
var DataBaseAlt24 = /*#__PURE__*/React.forwardRef(function DataBaseAlt24(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
  })), children);
});
var DataBaseAlt20 = /*#__PURE__*/React.forwardRef(function DataBaseAlt20(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
  })), children);
});
var DataBaseAlt16 = /*#__PURE__*/React.forwardRef(function DataBaseAlt16(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
  })), children);
});
var DataCategorical32 = /*#__PURE__*/React.forwardRef(function DataCategorical32(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h-10c-.5522 0-1-.4478-1-1v-10c0-.5522.4478-1 1-1h10c.5522 0 1 .4478 1 1v10c0 .5522-.4478 1-1 1zm-9-2h8v-8h-8v8zM8 30c-3.3083 0-6-2.6917-6-6s2.6917-6 6-6 6 2.6917 6 6-2.6917 6-6 6zm0-10c-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4-1.7944-4-4-4zM22 14h-12c-.3604 0-.6926-.1938-.8701-.5073s-.1729-.6982.0127-1.0072L15.1446 2.4822c.1937-.3229.5246-.4822.8554-.4822s.6617.1593.8554.4822l6.002 10.0033c.1855.309.1902.6937.0127 1.0072s-.5098.5073-.8701.5073zm-10.2339-2h8.4678l-4.2339-7.0564-4.2339 7.0564z"
  })), children);
});
var DataCategorical24 = /*#__PURE__*/React.forwardRef(function DataCategorical24(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h-10c-.5522 0-1-.4478-1-1v-10c0-.5522.4478-1 1-1h10c.5522 0 1 .4478 1 1v10c0 .5522-.4478 1-1 1zm-9-2h8v-8h-8v8zM8 30c-3.3083 0-6-2.6917-6-6s2.6917-6 6-6 6 2.6917 6 6-2.6917 6-6 6zm0-10c-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4-1.7944-4-4-4zM22 14h-12c-.3604 0-.6926-.1938-.8701-.5073s-.1729-.6982.0127-1.0072L15.1446 2.4822c.1937-.3229.5246-.4822.8554-.4822s.6617.1593.8554.4822l6.002 10.0033c.1855.309.1902.6937.0127 1.0072s-.5098.5073-.8701.5073zm-10.2339-2h8.4678l-4.2339-7.0564-4.2339 7.0564z"
  })), children);
});
var DataCategorical20 = /*#__PURE__*/React.forwardRef(function DataCategorical20(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h-10c-.5522 0-1-.4478-1-1v-10c0-.5522.4478-1 1-1h10c.5522 0 1 .4478 1 1v10c0 .5522-.4478 1-1 1zm-9-2h8v-8h-8v8zM8 30c-3.3083 0-6-2.6917-6-6s2.6917-6 6-6 6 2.6917 6 6-2.6917 6-6 6zm0-10c-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4-1.7944-4-4-4zM22 14h-12c-.3604 0-.6926-.1938-.8701-.5073s-.1729-.6982.0127-1.0072L15.1446 2.4822c.1937-.3229.5246-.4822.8554-.4822s.6617.1593.8554.4822l6.002 10.0033c.1855.309.1902.6937.0127 1.0072s-.5098.5073-.8701.5073zm-10.2339-2h8.4678l-4.2339-7.0564-4.2339 7.0564z"
  })), children);
});
var DataCategorical16 = /*#__PURE__*/React.forwardRef(function DataCategorical16(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h-10c-.5522 0-1-.4478-1-1v-10c0-.5522.4478-1 1-1h10c.5522 0 1 .4478 1 1v10c0 .5522-.4478 1-1 1zm-9-2h8v-8h-8v8zM8 30c-3.3083 0-6-2.6917-6-6s2.6917-6 6-6 6 2.6917 6 6-2.6917 6-6 6zm0-10c-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4-1.7944-4-4-4zM22 14h-12c-.3604 0-.6926-.1938-.8701-.5073s-.1729-.6982.0127-1.0072L15.1446 2.4822c.1937-.3229.5246-.4822.8554-.4822s.6617.1593.8554.4822l6.002 10.0033c.1855.309.1902.6937.0127 1.0072s-.5098.5073-.8701.5073zm-10.2339-2h8.4678l-4.2339-7.0564-4.2339 7.0564z"
  })), children);
});
var DataCenter32 = /*#__PURE__*/React.forwardRef(function DataCenter32(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
  })), children);
});
var DataCenter24 = /*#__PURE__*/React.forwardRef(function DataCenter24(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
  })), children);
});
var DataCenter20 = /*#__PURE__*/React.forwardRef(function DataCenter20(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
  })), children);
});
var DataCenter16 = /*#__PURE__*/React.forwardRef(function DataCenter16(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H23V6a2.0023,2.0023,0,0,0-2-2H11A2.0023,2.0023,0,0,0,9,6v4H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM4,28V12H9v2H7v2H9v2H7v2H9v2H7v2H9v4Zm17,0H11V6H21Zm7,0H23V24h2V22H23V20h2V18H23V16h2V14H23V12h5Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H18V10H14zM14 12H18V14H14zM14 16H18V18H14z"
  })), children);
});
var DataCheck32 = /*#__PURE__*/React.forwardRef(function DataCheck32(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), children);
});
var DataCheck24 = /*#__PURE__*/React.forwardRef(function DataCheck24(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), children);
});
var DataCheck20 = /*#__PURE__*/React.forwardRef(function DataCheck20(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), children);
});
var DataCheck16 = /*#__PURE__*/React.forwardRef(function DataCheck16(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.18L20.41 24.59 19 26 23 30 30 23 28.59 21.59 23 27.18z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2h8V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), children);
});
var DataConnected32 = /*#__PURE__*/React.forwardRef(function DataConnected32(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), children);
});
var DataConnected24 = /*#__PURE__*/React.forwardRef(function DataConnected24(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), children);
});
var DataConnected20 = /*#__PURE__*/React.forwardRef(function DataConnected20(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), children);
});
var DataConnected16 = /*#__PURE__*/React.forwardRef(function DataConnected16(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M24.91,19.59a4.51,4.51,0,0,0-2.66-3.24,4.55,4.55,0,0,0-3.5,0,4.94,4.94,0,0,0-.64.35L15.3,13.89a4.53,4.53,0,1,0-1.41,1.41l2.81,2.81a4.48,4.48,0,0,0-.61,3.3,4.51,4.51,0,0,0,2.66,3.24,4.55,4.55,0,0,0,3.5,0,4.51,4.51,0,0,0,2.66-3.24,4.65,4.65,0,0,0,0-1.82ZM11.5,14A2.5,2.5,0,1,1,14,11.5,2.5,2.5,0,0,1,11.5,14Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30L2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), children);
});
var DataError32 = /*#__PURE__*/React.forwardRef(function DataError32(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
  })), children);
});
var DataError24 = /*#__PURE__*/React.forwardRef(function DataError24(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
  })), children);
});
var DataError20 = /*#__PURE__*/React.forwardRef(function DataError20(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
  })), children);
});
var DataError16 = /*#__PURE__*/React.forwardRef(function DataError16(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H18V27H8V21H26V5A2,2,0,0,0,24,3Zm0,16H8V13H24Zm0-8H8V5H24Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.415L27.586 23 25 25.587 22.414 23 21 24.415 23.586 27 21 29.586 22.414 31 25 28.414 27.586 31 29 29.586 26.414 27 29 24.415z"
  })), children);
});
var DataFormat32 = /*#__PURE__*/React.forwardRef(function DataFormat32(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var DataFormat24 = /*#__PURE__*/React.forwardRef(function DataFormat24(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var DataFormat20 = /*#__PURE__*/React.forwardRef(function DataFormat20(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var DataFormat16 = /*#__PURE__*/React.forwardRef(function DataFormat16(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H26V13H18zM6 19H14V21H6zM10 16a4 4 0 114-4A4.0045 4.0045 0 0110 16zm0-6a2 2 0 102 2A2.002 2.002 0 0010 10zM22 24a4 4 0 114-4A4.0045 4.0045 0 0122 24zm0-6a2 2 0 102 2A2.002 2.002 0 0022 18z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
var DataReference32 = /*#__PURE__*/React.forwardRef(function DataReference32(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM6 19L6 21 9.5859 21 4 26.5859 5.4141 28 11 22.4141 11 26 13 26 13 19 6 19z"
  })), children);
});
var DataReference24 = /*#__PURE__*/React.forwardRef(function DataReference24(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM6 19L6 21 9.5859 21 4 26.5859 5.4141 28 11 22.4141 11 26 13 26 13 19 6 19z"
  })), children);
});
var DataReference20 = /*#__PURE__*/React.forwardRef(function DataReference20(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM6 19L6 21 9.5859 21 4 26.5859 5.4141 28 11 22.4141 11 26 13 26 13 19 6 19z"
  })), children);
});
var DataReference16 = /*#__PURE__*/React.forwardRef(function DataReference16(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM6 19L6 21 9.5859 21 4 26.5859 5.4141 28 11 22.4141 11 26 13 26 13 19 6 19z"
  })), children);
});
var DataRegular32 = /*#__PURE__*/React.forwardRef(function DataRegular32(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-.4622,0-.8948.1133-1.2859.2998l-4.8289-4.8291c.699-.981,1.1147-2.1768,1.1147-3.4707,0-3.3086-2.6917-6-6-6-1.2937,0-2.4897.416-3.4709,1.1147l-4.8289-4.8286c.1865-.3911.2998-.8237.2998-1.2861,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3,1.3433,3,3,3c.4622,0,.8948-.1133,1.2859-.2998l4.8289,4.8291c-.699.981-1.1147,2.1768-1.1147,3.4707,0,3.3086,2.6917,6,6,6,1.2937,0,2.4897-.416,3.4709-1.1147l4.8289,4.8286c-.1865.3911-.2998.8237-.2998,1.2861,0,1.6567,1.3433,3,3,3s3-1.3433,3-3-1.3433-3-3-3Zm-11-4c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
var DataRegular24 = /*#__PURE__*/React.forwardRef(function DataRegular24(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-.4622,0-.8948.1133-1.2859.2998l-4.8289-4.8291c.699-.981,1.1147-2.1768,1.1147-3.4707,0-3.3086-2.6917-6-6-6-1.2937,0-2.4897.416-3.4709,1.1147l-4.8289-4.8286c.1865-.3911.2998-.8237.2998-1.2861,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3,1.3433,3,3,3c.4622,0,.8948-.1133,1.2859-.2998l4.8289,4.8291c-.699.981-1.1147,2.1768-1.1147,3.4707,0,3.3086,2.6917,6,6,6,1.2937,0,2.4897-.416,3.4709-1.1147l4.8289,4.8286c-.1865.3911-.2998.8237-.2998,1.2861,0,1.6567,1.3433,3,3,3s3-1.3433,3-3-1.3433-3-3-3Zm-11-4c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
var DataRegular20 = /*#__PURE__*/React.forwardRef(function DataRegular20(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-.4622,0-.8948.1133-1.2859.2998l-4.8289-4.8291c.699-.981,1.1147-2.1768,1.1147-3.4707,0-3.3086-2.6917-6-6-6-1.2937,0-2.4897.416-3.4709,1.1147l-4.8289-4.8286c.1865-.3911.2998-.8237.2998-1.2861,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3,1.3433,3,3,3c.4622,0,.8948-.1133,1.2859-.2998l4.8289,4.8291c-.699.981-1.1147,2.1768-1.1147,3.4707,0,3.3086,2.6917,6,6,6,1.2937,0,2.4897-.416,3.4709-1.1147l4.8289,4.8286c-.1865.3911-.2998.8237-.2998,1.2861,0,1.6567,1.3433,3,3,3s3-1.3433,3-3-1.3433-3-3-3Zm-11-4c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
var DataRegular16 = /*#__PURE__*/React.forwardRef(function DataRegular16(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-.4622,0-.8948.1133-1.2859.2998l-4.8289-4.8291c.699-.981,1.1147-2.1768,1.1147-3.4707,0-3.3086-2.6917-6-6-6-1.2937,0-2.4897.416-3.4709,1.1147l-4.8289-4.8286c.1865-.3911.2998-.8237.2998-1.2861,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3,1.3433,3,3,3c.4622,0,.8948-.1133,1.2859-.2998l4.8289,4.8291c-.699.981-1.1147,2.1768-1.1147,3.4707,0,3.3086,2.6917,6,6,6,1.2937,0,2.4897-.416,3.4709-1.1147l4.8289,4.8286c-.1865.3911-.2998.8237-.2998,1.2861,0,1.6567,1.3433,3,3,3s3-1.3433,3-3-1.3433-3-3-3Zm-11-4c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
var DataSet32 = /*#__PURE__*/React.forwardRef(function DataSet32(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM8.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0z"
  })), children);
});
var DataSet24 = /*#__PURE__*/React.forwardRef(function DataSet24(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM8.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0z"
  })), children);
});
var DataSet20 = /*#__PURE__*/React.forwardRef(function DataSet20(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM8.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0z"
  })), children);
});
var DataSet16 = /*#__PURE__*/React.forwardRef(function DataSet16(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12L25 3 23 3 23 5 20 5 20 7 23 7 23 12 20 12 20 14 28 14 28 12 25 12zM8.5 5c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM8.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0zM23.5 20c1.9299 0 3.5 1.5701 3.5 3.5s-1.5701 3.5-3.5 3.5-3.5-1.5701-3.5-3.5 1.5701-3.5 3.5-3.5m0-2c-3.0376 0-5.5 2.4624-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5h0z"
  })), children);
});
var DataStructured32 = /*#__PURE__*/React.forwardRef(function DataStructured32(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataStructured24 = /*#__PURE__*/React.forwardRef(function DataStructured24(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataStructured20 = /*#__PURE__*/React.forwardRef(function DataStructured20(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataStructured16 = /*#__PURE__*/React.forwardRef(function DataStructured16(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V18a2,2,0,0,0-2-2H17V12h9a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4v6a2,2,0,0,0,2,2h9v4H7a2,2,0,0,0-2,2v4.14a4,4,0,1,0,2,0V18h8v4H12v8h8V22H17V18h8v4.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26Zm10-2v4H14V24ZM6,10V4H26v6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataUnreal32 = /*#__PURE__*/React.forwardRef(function DataUnreal32(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 18.1318l-7-4c-.1536-.0879-.3248-.1318-.4961-.1318s-.3425.0439-.4961.1318l-7 4c-.3115.1777-.5039.5093-.5039.8682v8c0 .3589.1924.6904.5039.8682l7 4c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l7-4c.3115-.1777.5039-.5093.5039-.8682v-8c0-.3589-.1924-.6904-.5039-.8682zm-7.4961-1.98l4.9844 2.8481-4.9844 2.8481-4.9844-2.8481 4.9844-2.8481zm-6 4.5713l5 2.8569v5.6968l-5-2.8569v-5.6968zm7 8.5537v-5.6968l5-2.8569v5.6968l-5 2.8569zM28 19v5c0 1.1025-.8972 2-2 2h-3.1719l1.5859-1.5859-1.4141-1.4141-4 4 4 4 1.4141-1.4141-1.5859-1.5859h3.1719c2.2056 0 4-1.7944 4-4v-5h-2zM17.5039 15.0111l-2-1.1428c-.3115-.1781-.5039-.5094-.5039-.8683v-2h2v1.4197l1.4961.8549-.9922 1.7366zM25.5039 14.4175l-1.5039.8594v-2.2769h-2v2.2769l-1.5039-.8594-.9922 1.7368 3 1.7139c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l3-1.7139-.9922-1.7368zM28.4961 15.0111l-.9922-1.7366 1.4961-.8549v-1.4197h2v2c0 .3589-.1924.6902-.5039.8683l-2 1.1428zM25.4961 8.7256L24.5039 6.9888 23 7.8481 21.4961 6.9888 20.5039 8.7256 22 9.5801 22 11 24 11 24 9.5801 25.4961 8.7256zM30.4961 4.1318l-3-1.7144-.9922 1.7368 1.4805.8457-1.4805.8457.9922 1.7368 1.5039-.8594v2.2769h2v-4c0-.3589-.1924-.6904-.5039-.8682zM24.5039 3.0111l-1.5039-.8594-1.5039.8594-.9922-1.7366 2-1.1428C22.6575.0439 22.8287 0 23 0s.3425.0439.4961.1317l2 1.1428-.9922 1.7366zM19.4961 4.1543l-.9922-1.7368-3 1.7144c-.3115.1777-.5039.5093-.5039.8682v4h2v-2.2769l1.5039.8594.9922-1.7368-1.4805-.8457 1.4805-.8457zM9 1l-1.4141 1.4141 1.5859 1.5859h-3.1719c-2.2056 0-4 1.7944-4 4v5h2v-5c0-1.1025.8972-2 2-2h3.1719l-1.5859 1.5859 1.4141 1.4141 4-4L9 1z"
  })), children);
});
var DataUnreal24 = /*#__PURE__*/React.forwardRef(function DataUnreal24(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 18.1318l-7-4c-.1536-.0879-.3248-.1318-.4961-.1318s-.3425.0439-.4961.1318l-7 4c-.3115.1777-.5039.5093-.5039.8682v8c0 .3589.1924.6904.5039.8682l7 4c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l7-4c.3115-.1777.5039-.5093.5039-.8682v-8c0-.3589-.1924-.6904-.5039-.8682zm-7.4961-1.98l4.9844 2.8481-4.9844 2.8481-4.9844-2.8481 4.9844-2.8481zm-6 4.5713l5 2.8569v5.6968l-5-2.8569v-5.6968zm7 8.5537v-5.6968l5-2.8569v5.6968l-5 2.8569zM28 19v5c0 1.1025-.8972 2-2 2h-3.1719l1.5859-1.5859-1.4141-1.4141-4 4 4 4 1.4141-1.4141-1.5859-1.5859h3.1719c2.2056 0 4-1.7944 4-4v-5h-2zM17.5039 15.0111l-2-1.1428c-.3115-.1781-.5039-.5094-.5039-.8683v-2h2v1.4197l1.4961.8549-.9922 1.7366zM25.5039 14.4175l-1.5039.8594v-2.2769h-2v2.2769l-1.5039-.8594-.9922 1.7368 3 1.7139c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l3-1.7139-.9922-1.7368zM28.4961 15.0111l-.9922-1.7366 1.4961-.8549v-1.4197h2v2c0 .3589-.1924.6902-.5039.8683l-2 1.1428zM25.4961 8.7256L24.5039 6.9888 23 7.8481 21.4961 6.9888 20.5039 8.7256 22 9.5801 22 11 24 11 24 9.5801 25.4961 8.7256zM30.4961 4.1318l-3-1.7144-.9922 1.7368 1.4805.8457-1.4805.8457.9922 1.7368 1.5039-.8594v2.2769h2v-4c0-.3589-.1924-.6904-.5039-.8682zM24.5039 3.0111l-1.5039-.8594-1.5039.8594-.9922-1.7366 2-1.1428C22.6575.0439 22.8287 0 23 0s.3425.0439.4961.1317l2 1.1428-.9922 1.7366zM19.4961 4.1543l-.9922-1.7368-3 1.7144c-.3115.1777-.5039.5093-.5039.8682v4h2v-2.2769l1.5039.8594.9922-1.7368-1.4805-.8457 1.4805-.8457zM9 1l-1.4141 1.4141 1.5859 1.5859h-3.1719c-2.2056 0-4 1.7944-4 4v5h2v-5c0-1.1025.8972-2 2-2h3.1719l-1.5859 1.5859 1.4141 1.4141 4-4L9 1z"
  })), children);
});
var DataUnreal20 = /*#__PURE__*/React.forwardRef(function DataUnreal20(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 18.1318l-7-4c-.1536-.0879-.3248-.1318-.4961-.1318s-.3425.0439-.4961.1318l-7 4c-.3115.1777-.5039.5093-.5039.8682v8c0 .3589.1924.6904.5039.8682l7 4c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l7-4c.3115-.1777.5039-.5093.5039-.8682v-8c0-.3589-.1924-.6904-.5039-.8682zm-7.4961-1.98l4.9844 2.8481-4.9844 2.8481-4.9844-2.8481 4.9844-2.8481zm-6 4.5713l5 2.8569v5.6968l-5-2.8569v-5.6968zm7 8.5537v-5.6968l5-2.8569v5.6968l-5 2.8569zM28 19v5c0 1.1025-.8972 2-2 2h-3.1719l1.5859-1.5859-1.4141-1.4141-4 4 4 4 1.4141-1.4141-1.5859-1.5859h3.1719c2.2056 0 4-1.7944 4-4v-5h-2zM17.5039 15.0111l-2-1.1428c-.3115-.1781-.5039-.5094-.5039-.8683v-2h2v1.4197l1.4961.8549-.9922 1.7366zM25.5039 14.4175l-1.5039.8594v-2.2769h-2v2.2769l-1.5039-.8594-.9922 1.7368 3 1.7139c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l3-1.7139-.9922-1.7368zM28.4961 15.0111l-.9922-1.7366 1.4961-.8549v-1.4197h2v2c0 .3589-.1924.6902-.5039.8683l-2 1.1428zM25.4961 8.7256L24.5039 6.9888 23 7.8481 21.4961 6.9888 20.5039 8.7256 22 9.5801 22 11 24 11 24 9.5801 25.4961 8.7256zM30.4961 4.1318l-3-1.7144-.9922 1.7368 1.4805.8457-1.4805.8457.9922 1.7368 1.5039-.8594v2.2769h2v-4c0-.3589-.1924-.6904-.5039-.8682zM24.5039 3.0111l-1.5039-.8594-1.5039.8594-.9922-1.7366 2-1.1428C22.6575.0439 22.8287 0 23 0s.3425.0439.4961.1317l2 1.1428-.9922 1.7366zM19.4961 4.1543l-.9922-1.7368-3 1.7144c-.3115.1777-.5039.5093-.5039.8682v4h2v-2.2769l1.5039.8594.9922-1.7368-1.4805-.8457 1.4805-.8457zM9 1l-1.4141 1.4141 1.5859 1.5859h-3.1719c-2.2056 0-4 1.7944-4 4v5h2v-5c0-1.1025.8972-2 2-2h3.1719l-1.5859 1.5859 1.4141 1.4141 4-4L9 1z"
  })), children);
});
var DataUnreal16 = /*#__PURE__*/React.forwardRef(function DataUnreal16(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 18.1318l-7-4c-.1536-.0879-.3248-.1318-.4961-.1318s-.3425.0439-.4961.1318l-7 4c-.3115.1777-.5039.5093-.5039.8682v8c0 .3589.1924.6904.5039.8682l7 4c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l7-4c.3115-.1777.5039-.5093.5039-.8682v-8c0-.3589-.1924-.6904-.5039-.8682zm-7.4961-1.98l4.9844 2.8481-4.9844 2.8481-4.9844-2.8481 4.9844-2.8481zm-6 4.5713l5 2.8569v5.6968l-5-2.8569v-5.6968zm7 8.5537v-5.6968l5-2.8569v5.6968l-5 2.8569zM28 19v5c0 1.1025-.8972 2-2 2h-3.1719l1.5859-1.5859-1.4141-1.4141-4 4 4 4 1.4141-1.4141-1.5859-1.5859h3.1719c2.2056 0 4-1.7944 4-4v-5h-2zM17.5039 15.0111l-2-1.1428c-.3115-.1781-.5039-.5094-.5039-.8683v-2h2v1.4197l1.4961.8549-.9922 1.7366zM25.5039 14.4175l-1.5039.8594v-2.2769h-2v2.2769l-1.5039-.8594-.9922 1.7368 3 1.7139c.1536.0879.325.1318.4961.1318s.3425-.0439.4961-.1318l3-1.7139-.9922-1.7368zM28.4961 15.0111l-.9922-1.7366 1.4961-.8549v-1.4197h2v2c0 .3589-.1924.6902-.5039.8683l-2 1.1428zM25.4961 8.7256L24.5039 6.9888 23 7.8481 21.4961 6.9888 20.5039 8.7256 22 9.5801 22 11 24 11 24 9.5801 25.4961 8.7256zM30.4961 4.1318l-3-1.7144-.9922 1.7368 1.4805.8457-1.4805.8457.9922 1.7368 1.5039-.8594v2.2769h2v-4c0-.3589-.1924-.6904-.5039-.8682zM24.5039 3.0111l-1.5039-.8594-1.5039.8594-.9922-1.7366 2-1.1428C22.6575.0439 22.8287 0 23 0s.3425.0439.4961.1317l2 1.1428-.9922 1.7366zM19.4961 4.1543l-.9922-1.7368-3 1.7144c-.3115.1777-.5039.5093-.5039.8682v4h2v-2.2769l1.5039.8594.9922-1.7368-1.4805-.8457 1.4805-.8457zM9 1l-1.4141 1.4141 1.5859 1.5859h-3.1719c-2.2056 0-4 1.7944-4 4v5h2v-5c0-1.1025.8972-2 2-2h3.1719l-1.5859 1.5859 1.4141 1.4141 4-4L9 1z"
  })), children);
});
var DataUnstructured32 = /*#__PURE__*/React.forwardRef(function DataUnstructured32(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataUnstructured24 = /*#__PURE__*/React.forwardRef(function DataUnstructured24(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataUnstructured20 = /*#__PURE__*/React.forwardRef(function DataUnstructured20(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataUnstructured16 = /*#__PURE__*/React.forwardRef(function DataUnstructured16(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 006 22zM16 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0016 2zM26 4a2 2 0 11-2 2 2 2 0 012-2m0-2a4 4 0 104 4A4 4 0 0026 2zM18 24v4H14V24h4m2-2H12v8h8z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H7V10h3V2H2v8H5v5a2,2,0,0,0,2,2H25v5.14a4,4,0,1,0,2,0ZM4,4H8V8H4ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
var DataView32 = /*#__PURE__*/React.forwardRef(function DataView32(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "1"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "24",
    r: "1"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
  })), children);
});
var DataView24 = /*#__PURE__*/React.forwardRef(function DataView24(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "1"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "24",
    r: "1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
  })), children);
});
var DataView20 = /*#__PURE__*/React.forwardRef(function DataView20(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "1"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "24",
    r: "1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
  })), children);
});
var DataView16 = /*#__PURE__*/React.forwardRef(function DataView16(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "1"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "24",
    r: "1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"
  })), children);
});
var DataViewAlt32 = /*#__PURE__*/React.forwardRef(function DataViewAlt32(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
  })), children);
});
var DataViewAlt24 = /*#__PURE__*/React.forwardRef(function DataViewAlt24(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
  })), children);
});
var DataViewAlt20 = /*#__PURE__*/React.forwardRef(function DataViewAlt20(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
  })), children);
});
var DataViewAlt16 = /*#__PURE__*/React.forwardRef(function DataViewAlt16(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM7 17H12V19H7zM7 12H19V14H7zM7 7H19V9H7z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z"
  })), children);
});
var DataAccessor32 = /*#__PURE__*/React.forwardRef(function DataAccessor32(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
  })), children);
});
var DataAccessor24 = /*#__PURE__*/React.forwardRef(function DataAccessor24(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
  })), children);
});
var DataAccessor20 = /*#__PURE__*/React.forwardRef(function DataAccessor20(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
  })), children);
});
var DataAccessor16 = /*#__PURE__*/React.forwardRef(function DataAccessor16(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13a2.9609,2.9609,0,0,0-1.2854.3008L17.4141,11l2.3-2.3008A2.9609,2.9609,0,0,0,21,9a3,3,0,1,0-3-3,2.9665,2.9665,0,0,0,.3,1.2852L16,9.5859,13.7,7.2852A2.9665,2.9665,0,0,0,14,6a3,3,0,1,0-3,3,2.9609,2.9609,0,0,0,1.2854-.3008L14.5859,11l-2.3005,2.3008A2.9609,2.9609,0,0,0,11,13a3,3,0,1,0,3,3,2.9665,2.9665,0,0,0-.3-1.2852L16,12.4141l2.3,2.3007A2.9665,2.9665,0,0,0,18,16a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,5ZM10,6a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,10,6Zm1,11a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,11,17Zm10,0a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,17Z"
  })), children);
});
var DataAnalytics32 = /*#__PURE__*/React.forwardRef(function DataAnalytics32(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H14V17H12zM7 13H9V17H7zM2 7H4V17H2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28.5859l-7.5522-7.5522c1.5918-1.9082,2.5522-4.3604,2.5522-7.0337,0-6.0654-4.9346-11-11-11-2.4026,0-4.6853.7607-6.6013,2.2002l1.2012,1.5991c1.5669-1.1772,3.4343-1.7993,5.4001-1.7993,4.9626,0,9,4.0371,9,9s-4.0374,9-9,9c-2.8574,0-5.4819-1.312-7.2007-3.6001l-1.5991,1.2017c2.1001,2.7949,5.3076,4.3984,8.7998,4.3984,2.6733,0,5.1255-.9604,7.0337-2.5522l7.5522,7.5522,1.4141-1.4141Z"
  })), children);
});
var DataAnalytics24 = /*#__PURE__*/React.forwardRef(function DataAnalytics24(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H14V17H12zM7 13H9V17H7zM2 7H4V17H2z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28.5859l-7.5522-7.5522c1.5918-1.9082,2.5522-4.3604,2.5522-7.0337,0-6.0654-4.9346-11-11-11-2.4026,0-4.6853.7607-6.6013,2.2002l1.2012,1.5991c1.5669-1.1772,3.4343-1.7993,5.4001-1.7993,4.9626,0,9,4.0371,9,9s-4.0374,9-9,9c-2.8574,0-5.4819-1.312-7.2007-3.6001l-1.5991,1.2017c2.1001,2.7949,5.3076,4.3984,8.7998,4.3984,2.6733,0,5.1255-.9604,7.0337-2.5522l7.5522,7.5522,1.4141-1.4141Z"
  })), children);
});
var DataAnalytics20 = /*#__PURE__*/React.forwardRef(function DataAnalytics20(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H14V17H12zM7 13H9V17H7zM2 7H4V17H2z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28.5859l-7.5522-7.5522c1.5918-1.9082,2.5522-4.3604,2.5522-7.0337,0-6.0654-4.9346-11-11-11-2.4026,0-4.6853.7607-6.6013,2.2002l1.2012,1.5991c1.5669-1.1772,3.4343-1.7993,5.4001-1.7993,4.9626,0,9,4.0371,9,9s-4.0374,9-9,9c-2.8574,0-5.4819-1.312-7.2007-3.6001l-1.5991,1.2017c2.1001,2.7949,5.3076,4.3984,8.7998,4.3984,2.6733,0,5.1255-.9604,7.0337-2.5522l7.5522,7.5522,1.4141-1.4141Z"
  })), children);
});
var DataAnalytics16 = /*#__PURE__*/React.forwardRef(function DataAnalytics16(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H14V17H12zM7 13H9V17H7zM2 7H4V17H2z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28.5859l-7.5522-7.5522c1.5918-1.9082,2.5522-4.3604,2.5522-7.0337,0-6.0654-4.9346-11-11-11-2.4026,0-4.6853.7607-6.6013,2.2002l1.2012,1.5991c1.5669-1.1772,3.4343-1.7993,5.4001-1.7993,4.9626,0,9,4.0371,9,9s-4.0374,9-9,9c-2.8574,0-5.4819-1.312-7.2007-3.6001l-1.5991,1.2017c2.1001,2.7949,5.3076,4.3984,8.7998,4.3984,2.6733,0,5.1255-.9604,7.0337-2.5522l7.5522,7.5522,1.4141-1.4141Z"
  })), children);
});
var DataBackup32 = /*#__PURE__*/React.forwardRef(function DataBackup32(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "15",
    r: "1"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
  })), children);
});
var DataBackup24 = /*#__PURE__*/React.forwardRef(function DataBackup24(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "15",
    r: "1"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
  })), children);
});
var DataBackup20 = /*#__PURE__*/React.forwardRef(function DataBackup20(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "15",
    r: "1"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
  })), children);
});
var DataBackup16 = /*#__PURE__*/React.forwardRef(function DataBackup16(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "15",
    r: "1"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H4V20h8V18H4V12H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V26a2,2,0,0,0,2,2h8ZM4,4H20v6H4Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v2.4131A6.996,6.996,0,1,0,22,30V28a5,5,0,1,1,4.5762-7H24v2h6V17Z"
  })), children);
});
var DataBin32 = /*#__PURE__*/React.forwardRef(function DataBin32(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
  })), children);
});
var DataBin24 = /*#__PURE__*/React.forwardRef(function DataBin24(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
  })), children);
});
var DataBin20 = /*#__PURE__*/React.forwardRef(function DataBin20(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
  })), children);
});
var DataBin16 = /*#__PURE__*/React.forwardRef(function DataBin16(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H20a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zm0 2v7H20V4zm0 9v6H20V13zM20 28V21h8v7zM12 15L10 15 10 13 8 13 8 15 6 15 6 17 8 17 8 19 10 19 10 17 12 17 12 15z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6V4H10A2.0023,2.0023,0,0,0,8,6V9.08A6.99,6.99,0,0,0,8,22.92V26a2.0023,2.0023,0,0,0,2,2h6V26H10V22.92A6.99,6.99,0,0,0,10,9.08V6ZM14,16a5,5,0,1,1-5-5A5.0059,5.0059,0,0,1,14,16Z"
  })), children);
});
var DataBlob32 = /*#__PURE__*/React.forwardRef(function DataBlob32(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
  })), children);
});
var DataBlob24 = /*#__PURE__*/React.forwardRef(function DataBlob24(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
  })), children);
});
var DataBlob20 = /*#__PURE__*/React.forwardRef(function DataBlob20(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
  })), children);
});
var DataBlob16 = /*#__PURE__*/React.forwardRef(function DataBlob16(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H15V14H13zM8 7H10V14H8zM22 14H20a2.0021 2.0021 0 01-2-2V9a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0122 14zM20 9v3h2V9zM22 18H24V25H22zM8 18H10V25H8zM17 25H15a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v3A2.0021 2.0021 0 0117 25zm-2-5v3h2V20z"
  })), children);
});
var DataClass32 = /*#__PURE__*/React.forwardRef(function DataClass32(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
  })), children);
});
var DataClass24 = /*#__PURE__*/React.forwardRef(function DataClass24(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
  })), children);
});
var DataClass20 = /*#__PURE__*/React.forwardRef(function DataClass20(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
  })), children);
});
var DataClass16 = /*#__PURE__*/React.forwardRef(function DataClass16(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a3.9612,3.9612,0,0,0-2.02.5657l-2.8586-2.8585,2.293-2.293a2,2,0,0,0,0-2.8284l-6-6a2,2,0,0,0-2.8284,0l-6,6a2,2,0,0,0,0,2.8284l2.293,2.293L8.02,16.5657A4.043,4.043,0,1,0,9.4343,17.98l2.8585-2.8586,2.293,2.293A1.9773,1.9773,0,0,0,15,17.7233V22H12v8h8V22H17V17.7233a1.9773,1.9773,0,0,0,.4142-.3091l2.293-2.293L22.5657,17.98A3.9885,3.9885,0,1,0,26,16ZM8,20a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,20Zm10,4v4H14V24h4Zm-2-8-6-6,6-6,6,6Zm10,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,22Z"
  })), children);
});
var DataCollection32 = /*#__PURE__*/React.forwardRef(function DataCollection32(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
  })), children);
});
var DataCollection24 = /*#__PURE__*/React.forwardRef(function DataCollection24(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
  })), children);
});
var DataCollection20 = /*#__PURE__*/React.forwardRef(function DataCollection20(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
  })), children);
});
var DataCollection16 = /*#__PURE__*/React.forwardRef(function DataCollection16(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17L30 15 23.83 15 26.41 12.41 25 11 20 16 25 21 26.41 19.59 23.83 17 30 17zM15 23.83L15 30 17 30 17 23.83 19.59 26.41 21 25 16 20 11 25 12.41 26.41 15 23.83zM7 11L5.59 12.41 8.17 15 2 15 2 17 8.17 17 5.59 19.59 7 21 12 16 7 11zM17 8.17L17 2 15 2 15 8.17 12.41 5.59 11 7 16 12 21 7 19.59 5.59 17 8.17z"
  })), children);
});
var DataDefinition32 = /*#__PURE__*/React.forwardRef(function DataDefinition32(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
  })), children);
});
var DataDefinition24 = /*#__PURE__*/React.forwardRef(function DataDefinition24(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
  })), children);
});
var DataDefinition20 = /*#__PURE__*/React.forwardRef(function DataDefinition20(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
  })), children);
});
var DataDefinition16 = /*#__PURE__*/React.forwardRef(function DataDefinition16(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30a.9967.9967,0,0,1-.707-.293L8.5859,19A2.0126,2.0126,0,0,1,8,17.5859V10a2.002,2.002,0,0,1,2-2h7.5859A1.9864,1.9864,0,0,1,19,8.5859L29.707,19.293a.9994.9994,0,0,1,0,1.414l-9,9A.9967.9967,0,0,1,20,30ZM10,10v7.5859l10,10L27.5859,20l-10-10Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8H28V4H4V28h8Z"
  })), children);
});
var DataDiode32 = /*#__PURE__*/React.forwardRef(function DataDiode32(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
  })), children);
});
var DataDiode24 = /*#__PURE__*/React.forwardRef(function DataDiode24(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
  })), children);
});
var DataDiode20 = /*#__PURE__*/React.forwardRef(function DataDiode20(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
  })), children);
});
var DataDiode16 = /*#__PURE__*/React.forwardRef(function DataDiode16(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27V7H25v8H22V7H20v7.8262L7.5239,7.1484A1,1,0,0,0,6,8v7H2v2H6v7a1,1,0,0,0,1.5239.8516L20,17.1738V25h2V17h3v8h2V17h3ZM8,22.21V9.79L18.0918,16Z"
  })), children);
});
var DataEnrichment32 = /*#__PURE__*/React.forwardRef(function DataEnrichment32(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichment24 = /*#__PURE__*/React.forwardRef(function DataEnrichment24(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch2 || (_switch2 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichment20 = /*#__PURE__*/React.forwardRef(function DataEnrichment20(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch3 || (_switch3 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichment16 = /*#__PURE__*/React.forwardRef(function DataEnrichment16(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch4 || (_switch4 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichmentAdd32 = /*#__PURE__*/React.forwardRef(function DataEnrichmentAdd32(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch5 || (_switch5 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichmentAdd24 = /*#__PURE__*/React.forwardRef(function DataEnrichmentAdd24(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch6 || (_switch6 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichmentAdd20 = /*#__PURE__*/React.forwardRef(function DataEnrichmentAdd20(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch7 || (_switch7 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataEnrichmentAdd16 = /*#__PURE__*/React.forwardRef(function DataEnrichmentAdd16(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch8 || (_switch8 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataPlayer32 = /*#__PURE__*/React.forwardRef(function DataPlayer32(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
  })), children);
});
var DataPlayer24 = /*#__PURE__*/React.forwardRef(function DataPlayer24(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
  })), children);
});
var DataPlayer20 = /*#__PURE__*/React.forwardRef(function DataPlayer20(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
  })), children);
});
var DataPlayer16 = /*#__PURE__*/React.forwardRef(function DataPlayer16(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v2H15.8164a2.983 2.983 0 00-5.6328 0H4V24H2v6H4V28h6.1836a2.983 2.983 0 005.6328 0H28v2h2V24zM13 7.5L13 16.499 13 16.499 21 12 13 7.5z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22A10,10,0,1,1,26,12,10.0113,10.0113,0,0,1,16,22ZM16,4a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,4Z"
  })), children);
});
var DataQualityDefinition32 = /*#__PURE__*/React.forwardRef(function DataQualityDefinition32(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch9 || (_switch9 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataQualityDefinition24 = /*#__PURE__*/React.forwardRef(function DataQualityDefinition24(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch10 || (_switch10 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataQualityDefinition20 = /*#__PURE__*/React.forwardRef(function DataQualityDefinition20(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch11 || (_switch11 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataQualityDefinition16 = /*#__PURE__*/React.forwardRef(function DataQualityDefinition16(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch12 || (_switch12 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var DataRefinery32 = /*#__PURE__*/React.forwardRef(function DataRefinery32(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
  })), children);
});
var DataRefinery24 = /*#__PURE__*/React.forwardRef(function DataRefinery24(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
  })), children);
});
var DataRefinery20 = /*#__PURE__*/React.forwardRef(function DataRefinery20(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
  })), children);
});
var DataRefinery16 = /*#__PURE__*/React.forwardRef(function DataRefinery16(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
  })), children);
});
var DataRefineryReference32 = /*#__PURE__*/React.forwardRef(function DataRefineryReference32(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), children);
});
var DataRefineryReference24 = /*#__PURE__*/React.forwardRef(function DataRefineryReference24(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), children);
});
var DataRefineryReference20 = /*#__PURE__*/React.forwardRef(function DataRefineryReference20(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), children);
});
var DataRefineryReference16 = /*#__PURE__*/React.forwardRef(function DataRefineryReference16(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), children);
});
var DataShare32 = /*#__PURE__*/React.forwardRef(function DataShare32(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
  })), children);
});
var DataShare24 = /*#__PURE__*/React.forwardRef(function DataShare24(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
  })), children);
});
var DataShare20 = /*#__PURE__*/React.forwardRef(function DataShare20(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
  })), children);
});
var DataShare16 = /*#__PURE__*/React.forwardRef(function DataShare16(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
  })), children);
});
var DataTable32 = /*#__PURE__*/React.forwardRef(function DataTable32(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
  })), children);
});
var DataTable24 = /*#__PURE__*/React.forwardRef(function DataTable24(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
  })), children);
});
var DataTable20 = /*#__PURE__*/React.forwardRef(function DataTable20(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
  })), children);
});
var DataTable16 = /*#__PURE__*/React.forwardRef(function DataTable16(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
  })), children);
});
var DataTableReference32 = /*#__PURE__*/React.forwardRef(function DataTableReference32(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
var DataTableReference24 = /*#__PURE__*/React.forwardRef(function DataTableReference24(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
var DataTableReference20 = /*#__PURE__*/React.forwardRef(function DataTableReference20(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
var DataTableReference16 = /*#__PURE__*/React.forwardRef(function DataTableReference16(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});
var DataVis_132 = /*#__PURE__*/React.forwardRef(function DataVis_132(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
var DataVis_124 = /*#__PURE__*/React.forwardRef(function DataVis_124(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
var DataVis_120 = /*#__PURE__*/React.forwardRef(function DataVis_120(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
var DataVis_116 = /*#__PURE__*/React.forwardRef(function DataVis_116(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
var DataVis_232 = /*#__PURE__*/React.forwardRef(function DataVis_232(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
  })), children);
});
var DataVis_224 = /*#__PURE__*/React.forwardRef(function DataVis_224(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
  })), children);
});
var DataVis_220 = /*#__PURE__*/React.forwardRef(function DataVis_220(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
  })), children);
});
var DataVis_216 = /*#__PURE__*/React.forwardRef(function DataVis_216(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
  })), children);
});
var DataVis_332 = /*#__PURE__*/React.forwardRef(function DataVis_332(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
  })), children);
});
var DataVis_324 = /*#__PURE__*/React.forwardRef(function DataVis_324(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
  })), children);
});
var DataVis_320 = /*#__PURE__*/React.forwardRef(function DataVis_320(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
  })), children);
});
var DataVis_316 = /*#__PURE__*/React.forwardRef(function DataVis_316(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
  })), children);
});
var DataVis_432 = /*#__PURE__*/React.forwardRef(function DataVis_432(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
  })), children);
});
var DataVis_424 = /*#__PURE__*/React.forwardRef(function DataVis_424(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
  })), children);
});
var DataVis_420 = /*#__PURE__*/React.forwardRef(function DataVis_420(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
  })), children);
});
var DataVis_416 = /*#__PURE__*/React.forwardRef(function DataVis_416(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
  })), children);
});

export { Currency16, Currency20, CurrencyBaht16, CurrencyBaht20, CurrencyBaht24, CurrencyBaht32, CurrencyDollar16, CurrencyDollar20, CurrencyDollar24, CurrencyDollar32, CurrencyEuro16, CurrencyEuro20, CurrencyEuro24, CurrencyEuro32, CurrencyLira16, CurrencyLira20, CurrencyLira24, CurrencyLira32, CurrencyPound16, CurrencyPound20, CurrencyPound24, CurrencyPound32, CurrencyRuble16, CurrencyRuble20, CurrencyRuble24, CurrencyRuble32, CurrencyRupee16, CurrencyRupee20, CurrencyRupee24, CurrencyRupee32, CurrencyShekel16, CurrencyShekel20, CurrencyShekel24, CurrencyShekel32, CurrencyWon16, CurrencyWon20, CurrencyWon24, CurrencyWon32, CurrencyYen16, CurrencyYen20, CurrencyYen24, CurrencyYen32, Cursor_116, Cursor_120, Cursor_124, Cursor_132, Cursor_216, Cursor_220, Cursor_224, Cursor_232, Customer16, Customer20, Customer24, Customer32, CustomerService16, CustomerService20, CustomerService24, CustomerService32, Cut16, Cut20, Cut24, Cut32, CutOut16, CutOut20, CutOut24, CutOut32, Cyclist16, Cyclist20, Cyclist24, Cyclist32, Dashboard16, Dashboard20, Dashboard24, Dashboard32, DashboardReference16, DashboardReference20, DashboardReference24, DashboardReference32, DataAccessor16, DataAccessor20, DataAccessor24, DataAccessor32, DataAnalytics16, DataAnalytics20, DataAnalytics24, DataAnalytics32, DataBackup16, DataBackup20, DataBackup24, DataBackup32, DataBase16, DataBase20, DataBase24, DataBase32, DataBaseAlt16, DataBaseAlt20, DataBaseAlt24, DataBaseAlt32, DataBin16, DataBin20, DataBin24, DataBin32, DataBlob16, DataBlob20, DataBlob24, DataBlob32, DataCategorical16, DataCategorical20, DataCategorical24, DataCategorical32, DataCenter16, DataCenter20, DataCenter24, DataCenter32, DataCheck16, DataCheck20, DataCheck24, DataCheck32, DataClass16, DataClass20, DataClass24, DataClass32, DataCollection16, DataCollection20, DataCollection24, DataCollection32, DataConnected16, DataConnected20, DataConnected24, DataConnected32, DataDefinition16, DataDefinition20, DataDefinition24, DataDefinition32, DataDiode16, DataDiode20, DataDiode24, DataDiode32, DataEnrichment16, DataEnrichment20, DataEnrichment24, DataEnrichment32, DataEnrichmentAdd16, DataEnrichmentAdd20, DataEnrichmentAdd24, DataEnrichmentAdd32, DataError16, DataError20, DataError24, DataError32, DataFormat16, DataFormat20, DataFormat24, DataFormat32, DataPlayer16, DataPlayer20, DataPlayer24, DataPlayer32, DataQualityDefinition16, DataQualityDefinition20, DataQualityDefinition24, DataQualityDefinition32, DataReference16, DataReference20, DataReference24, DataReference32, DataRefinery16, DataRefinery20, DataRefinery24, DataRefinery32, DataRefineryReference16, DataRefineryReference20, DataRefineryReference24, DataRefineryReference32, DataRegular16, DataRegular20, DataRegular24, DataRegular32, DataSet16, DataSet20, DataSet24, DataSet32, DataShare16, DataShare20, DataShare24, DataShare32, DataStructured16, DataStructured20, DataStructured24, DataStructured32, DataTable16, DataTable20, DataTable24, DataTable32, DataTableReference16, DataTableReference20, DataTableReference24, DataTableReference32, DataUnreal16, DataUnreal20, DataUnreal24, DataUnreal32, DataUnstructured16, DataUnstructured20, DataUnstructured24, DataUnstructured32, DataView16, DataView20, DataView24, DataView32, DataViewAlt16, DataViewAlt20, DataViewAlt24, DataViewAlt32, DataVis_116, DataVis_120, DataVis_124, DataVis_132, DataVis_216, DataVis_220, DataVis_224, DataVis_232, DataVis_316, DataVis_320, DataVis_324, DataVis_332, DataVis_416, DataVis_420, DataVis_424, DataVis_432, Data_116, Data_120, Data_124, Data_132, Data_216, Data_220, Data_224, Data_232, QCY16, QCY20, QCY24, QCY32, QCZ16, QCZ20, QCZ24, QCZ32, WatsonHealthCutInHalf16, WatsonHealthCutInHalf20, WatsonHealthCutInHalf24, WatsonHealthCutInHalf32 };
